module.exports = __webpack_public_path__ + "static/media/celebrations.74802daa.jpg";